import React from "react";
import { FaTwitter, FaLinkedinIn, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { Icon } from "@iconify/react";

const Footer = () => {
  const scrollToSection = (id) => {
    if (window.location.pathname === "/") {
      // Home page pe ho -> direct scroll
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Dusre page pe ho -> home page pe redirect with hash
      window.location.href = "/#" + id;
    }
  };

  return (
    <div className="w-full py-20 h-auto border-b-[1px] border-b-black grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-4 gap-8">
      <div className="w-full h-full flex flex-col gap-8">
        {/* <img className="w-32" src={logo} alt="logo" /> */}
        <span className="text-[rgb(255_1_79/1)] text-2xl font-semibold">Portfolio</span>

        <div className="flex gap-4">
          <span className="bannerIcon">
            <Icon icon="logos:twitter" width="30" height="30" />
          </span>

          <span className="bannerIcon">
            <a
              href="https://wa.me/919129019994?text=May%20I%20help%20you%3F"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon icon="logos:whatsapp-icon" width="30" height="30" />
            </a>
          </span>

          <span className="bannerIcon">
            <Icon icon="skill-icons:instagram" width="30" height="30" />
          </span>
        </div>
      </div>

      <div className="w-full h-full">
        <h3 className="text-xl uppercase text-designColor tracking-wider">Quick Link</h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium py-6 overflow-hidden">
          {["home", "feature", "projects", "resume", "contact"].map((section) => (
            <li key={section}>
              <span
                onClick={() => scrollToSection(section)}
                className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer"
              >
                {section.charAt(0).toUpperCase() + section.slice(1)}
                <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="w-full h-full">
        <h3 className="text-xl uppercase text-designColor tracking-wider">Graphic Designer</h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden py-6">
          {[
            "Adobe After Effects",
            "Premiere Pro",
            "Photoshop",
            "Animate CC",
            "Illustrator",
          ].map((skill) => (
            <li key={skill}>
              <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
                {skill}
                <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="w-full h-full">
        <h3 className="text-xl uppercase text-designColor tracking-wider">Contact</h3>
        <ul className="flex flex-col gap-4 font-titleFont font-medium overflow-hidden py-6">
          <li>
            <span className="w-full text-lg relative hover:text-designColor duration-300 group cursor-pointer">
              +91 9129019994
              <span className="w-full h-[1px] bg-designColor inline-flex absolute left-0 -bottom-1 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300"></span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
